/********   用户整体数据统计相关    *********/
import { httpCreate } from './http';

const http = httpCreate('/srv/user/activity');

export const userActivity = {
	// 获取用户整体直播数据
	getUserStatistics(params) {
		return http.get('/statistics', { params });
	},
	/** 用户直播数据增量
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	increase(params) {
		return http.get('/increase', { params });
	},
	/** 用户收益数据折线图
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getUserFundChart(params) {
		return http.get('/getFundChart', { params });
	},
	/** 用户访问次数增量
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getParticipantsChart(params) {
		return http.get('/getParticipantsChart', { params });
	},
	/** 用户访问人数增量
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getParticipantsUVChart(params) {
		return http.get('/getParticipantsUVChart', { params });
	},
	/** 用户分享数增量
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getShareNumChart(params) {
		return http.get('/getShareNumChart', { params });
	},
	/** 用户直播省份统计
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getUserProvince(params) {
		return http.get('/province', { params });
	},
	/** 用户直播城市统计
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getUserCity(params) {
		return http.get('/city', { params });
	},
	/** 用户直播性别统计
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getUserSexParticipants(params) {
		return http.get('/sexParticipants', { params });
	},
	/** 用户直播来源统计
	 *
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getUserPlatformParticipants(params) {
		return http.get('/platformParticipants', { params });
	},
	// 获取用户直播省份明细
	getUserCityInfo(provinceId) {
		return http.get(`/city/${provinceId}`);
	},
};
